export var extname = function (filePath) {
  var lastDotIndex = filePath.lastIndexOf('.');
  var lastSlashIndex = Math.max(filePath.lastIndexOf('/'), filePath.lastIndexOf('\\'));
  // If there's no dot or the dot is before the last slash, return an empty string
  if (lastDotIndex === -1 || lastDotIndex < lastSlashIndex) {
    return '';
  }
  // Return the substring starting from the last dot
  return filePath.slice(lastDotIndex);
};
// // Example usage:
// console.log(extname('file.txt'));           // ".txt"
// console.log(extname('/path/to/file.txt')); // ".txt"
// console.log(extname('/path/to/file'));     // ""
// console.log(extname('.hiddenfile'));       // ""
// console.log(extname('file.with.dots.js')); // ".js"